export default "__VITE_ASSET__DFyasVeu__"